import React from 'react'
import { BackendKeywordTag } from '../../constants/tags'
import { getKeywordSizeLevel, getLocalizedName } from './utils'
import { KeywordButton } from './styled'

interface KeywordTagProps {
  keyword: BackendKeywordTag
  language: string
  minCount: number
  maxCount: number
  onSelect: (keywordId: number) => void
}

const KeywordTag = ({ keyword, language, minCount, maxCount, onSelect }: KeywordTagProps) => {
  const localizedName = getLocalizedName(keyword, language)
  const sizeLevel = getKeywordSizeLevel(keyword.count, minCount, maxCount)

  return (
    <KeywordButton
      $sizeLevel={sizeLevel}
      data-id={keyword.id}
      data-count={keyword.count}
      data-size-level={sizeLevel}
      onClick={() => onSelect(keyword.id)}
    >
      <span className="localizedName">{localizedName}</span>
      <span className="keywordCount">({keyword.count})</span>
    </KeywordButton>
  )
}

export default React.memo(KeywordTag)
